module.exports = __webpack_public_path__ + "./images/493bf8fd17c8ff8801638787c248456a.webp";